import "./Header.css";
import React, { lazy, Suspense, useContext, useEffect, useRef, useState } from "react";
import {
  IonButtons,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonLabel,
  IonText,
  IonCol,
  IonImg,
  IonIcon,
  IonMenuButton,
  IonRouterLink,
  IonList,
  IonRow,
  IonItemDivider,
  IonButton,
  IonPopover,
  IonContent,
  IonSelect,
  IonSelectOption,
  IonRadioGroup,
  IonRadio,
} from "@ionic/react";
import { Auth } from "aws-amplify";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import jwt_decode from "jwt-decode";
//import GroupsComponent from "../GroupsComponent";
import { getUserAttributes } from "../../services/Helpers";
import { exit, refresh } from "ionicons/icons";
import { useHistory } from "react-router";
import { Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select, SelectChangeEvent, Typography } from "@mui/material";
import jwtDecode from "jwt-decode";
import { useTranslation } from "react-i18next";
import * as ApiService from "../../services/ApiService";
import { useTranslations } from "../../hooks/useTranslations";
import i18n from "i18next";

const LazyLoadGroupsComponent = lazy(() => import("../GroupsComponent"));

const getDecodedAccessToken = (token: string) => {
  try {
    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
};

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Header: React.FC = () => {
  const history: any = useHistory();
  const timeoutRef = useRef<NodeJS.Timeout>();

  const { providerState } = useContext(ProviderContext);
  const { userState, setUserState } = useContext(ApplicationContext);
  const [userAttributes, setUserAttributes] = React.useState<any | undefined>(
    {}
  );
  const [userFullName, setUserName] = useState("");
  const [timeoutModal, setTimeoutModal] = useState(false)
  const [loading, setLoading] = useState(false)

  const [countdown, setCountdown] = useState(120); // Countdown for auto-logout
  const item = { src: "assets/img/icon.png" };

  const [language, setLanguage] = useState('en');
  const labels = useTranslations();

  // Restore saved language or default
  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "en";
    setLanguage(savedLang);
    loadTranslation(savedLang)
  }, [userState.authenticatedUser]);

  const handleLanguageChange = async (lang: string) => {
    try {
      setLanguage(lang);
      localStorage.setItem("lang", lang);

      // Fetch and apply language from backend
      loadTranslation(lang)
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  const loadTranslation = async (lang: string) => {
    try {

      const cached = localStorage.getItem(`translations_${lang}`);

      //Try using cache first
      if (cached) {
        const parsed = JSON.parse(cached);
        i18n.addResourceBundle(lang, "translation", parsed, true, true);
        i18n.changeLanguage(lang);
        i18n.emit("languageChanged", lang);
      }

      setLoading(true)

      //Then refresh from backend in background
      const response = await ApiService.loadTranslations(lang, userState.authenticatedUser);
      if (response) {
        setLoading(false)
        localStorage.setItem(
          `translations_${lang}`,
          JSON.stringify(response)
        );
      }
    } catch (error) {
      setLoading(false)
      //console.error("Error changing language loadTranslation():", error);
    } finally {
      setLoading(false)
    }

  }

  const logout = async () => {
    //setUserState({ authenticatedUser: undefined });
    Auth.signOut().then(() => {
      window.location.href = "/home"; // Redirect to login page
    });
  }

  const refreshSession = async () => {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const newSession: any = await new Promise((resolve, reject) => {
        cognitoUser.refreshSession(cognitoUser.getSignInUserSession().getRefreshToken(), (err, session) => {
          if (err) reject(err);
          else resolve(session);
        });
      });
      //window.location.reload();
      cognitoUser.signInUserSession = newSession;

      console.log("Session refreshed successfully");
      // console.log(newSession);
      // console.log((await Auth.currentAuthenticatedUser()).getSignInUserSession());
      setTimeoutModal(false);
    } catch (error) {
      console.error("Error refreshing session:", error);
    }
  };

  const handleClose = () => {
    setTimeoutModal(false);
    clearTimeout(timeoutRef.current);
  };

  const closeAfter30Sec = () => {
    clearTimeout(timeoutRef.current);
    setCountdown(120);
    timeoutRef.current = setTimeout(() => {
      logout();
    }, 120000);
  };

  useEffect(() => {
    const timecheck = 5 * 60 * 1000; // 5 minutes
    const inactivityTimer = setInterval(refreshTokenIfNecessary, timecheck);

    const user = userState.authenticatedUser;
    if (user) {
      user.attributes = jwtDecode(user.signInUserSession.idToken.jwtToken)
      setUserName(`${user.attributes.given_name} ${user.attributes.family_name}`);
      const attr = getUserAttributes(user.signInUserSession.idToken.jwtToken);
      setUserAttributes(attr);
    }

    return () => {
      clearInterval(inactivityTimer);
      clearTimeout(timeoutRef.current);
    };
  }, [userState]);

  useEffect(() => {
    if (timeoutModal) {
      const interval = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timeoutModal]);

  useEffect(() => {
    if (countdown <= 0) {
      logout();
    }
  }, [countdown]);

  async function refreshTokenIfNecessary() {
    try {
      const session = await Auth.currentSession();
      const currentTime = Math.floor(new Date().getTime() / 1000);
      const tokenExpirationTime = session.getIdToken().getExpiration();
      const refreshThreshold = 300; // 5 minutes before expiration

      if (tokenExpirationTime - currentTime < refreshThreshold) {
        setTimeoutModal(true);
        closeAfter30Sec();
      }
    } catch (error) {
      console.error("Error refreshing token:");
      setTimeoutModal(true);
      closeAfter30Sec();
    }
  }

  function toggleMenu() {
    const splitPane = document.querySelector("ion-split-pane");
    const windowWidth = window.innerWidth;
    const splitPaneShownAt = 992;
    const when = `(min-width: ${splitPaneShownAt}px)`;
    if (windowWidth >= splitPaneShownAt) {
      // split pane view is visible
      const open = splitPane.when === when;
      splitPane.when = open ? false : when;
    } else {
      // split pane view is not visible
      // toggle menu open
      const menu = splitPane.querySelector("ion-menu");
      return menu.open();
    }
  }

  function editProfile(profile) {
    history.push("/updateprofile", { user: profile.attributes });
  }

  const refresh = async () => {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const { refreshToken } = cognitoUser.getSignInUserSession();
    cognitoUser.refreshSession(refreshToken, (err, session) => {
      window.location.reload()
    })
  }

  return (
    <IonHeader className="header">
      <IonItem className="compact-item">
        <IonRow slot="end" style={{ alignItems: "center" }}>
          {loading && <CircularProgress size={20} style={{ marginRight: 10 }} />}
          <Button
            onClick={() => handleLanguageChange("en")}
            style={{
              fontWeight: language === "en" ? "bold" : "normal",
              textDecoration: language === "en" ? "underline" : "none",
              color: language === "en" ? "#007bff" : "inherit",
            }}
            variant="text"
          >🇺🇸 English</Button>

          <IonLabel style={{ margin: "0 8px" }}>|</IonLabel>

          <Button
            onClick={() => handleLanguageChange("es")}
            style={{
              fontWeight: language === "es" ? "bold" : "normal",
              textDecoration: language === "es" ? "underline" : "none",
              color: language === "es" ? "#007bff" : "inherit",
              marginRight: 20,
            }}
            variant="text"
          >🇪🇸 Español</Button>

          <IonRouterLink onClick={logout} className="link">
            &nbsp;{labels.Signout} <IonIcon icon={exit} className="link" />
          </IonRouterLink>
        </IonRow>

      </IonItem>
      <IonItem>
        <IonCol slot="start">
          <IonImg src={item.src} className="logo" />
        </IonCol>
        <IonCol slot="end">
          <IonItem>
            <IonLabel>{labels.Welcome} {userFullName}</IonLabel>
            {/* <IonRouterLink onClick={logout} className="link">
              &nbsp;Signout <IonIcon icon={exit} className="link" />
            </IonRouterLink> */}
          </IonItem>
          <IonItem>
            <IonLabel> {labels.Loggedinas} {userAttributes?.roles}</IonLabel>
            <IonRouterLink onClick={() => editProfile(userState.authenticatedUser)}>
              <IonText className="link">&nbsp;{labels.Edit}</IonText>
            </IonRouterLink>
          </IonItem>

        </IonCol>
        <IonCol slot="start">
          <IonTitle>
            <h3> {labels.MedlineHealth} </h3>
          </IonTitle>
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadGroupsComponent />
          </Suspense>
        </IonCol>
      </IonItem>
      <Modal
        open={timeoutModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography style={{ marginBottom: 5 }} id="modal-modal-title" variant="h5" component="h2">
            {labels.SessionTimedOut} ⌛
          </Typography>
          <Typography style={{ marginBottom: 10 }}>
            {labels.TookTooLong}
          </Typography>
          <Typography>
            {labels.SessionRefresh} {countdown} {labels.SessionSeconds}
          </Typography>
          <div style={{ marginTop: 20 }}>
            <Button variant="contained" onClick={refreshSession}>
              {labels.Refresh}
            </Button>
          </div>
        </Box>
      </Modal>
    </IonHeader>
  );
};

export default Header;
